/**
 * Application configuration constants
 */

export const API_CONFIG = {
  // Job polling settings
  POLL_INTERVAL_MS: 5000, // Poll every 5 seconds
  MAX_POLL_ATTEMPTS: 60, // 60 attempts * 5 seconds = 5 minutes max

  // API base URL (relative to current origin)
  BASE_URL: '/api',
};

export const UPLOAD_CONFIG = {
  // File upload limits
  MAX_FILE_SIZE_MB: 10,

  // Supported file types
  SUPPORTED_TYPES: {
    'text/plain': 'txt',
    'application/pdf': 'pdf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
    'application/msword': 'doc',
    'application/epub+zip': 'epub',
  },

  // Minimum text length for analysis
  MIN_TEXT_LENGTH: 50,
  MIN_PASTE_LENGTH: 100,
};

export const VOCAB_CONFIG = {
  // Grade level options
  GRADE_LEVELS: ['K-2', '3-5', '6-8', '9-12', 'College/Adult'],

  // Subject options
  SUBJECTS: [
    'English Literature',
    'History / Social Studies',
    'Science',
    'Social-Emotional Learning',
    'Foreign Language',
    'General / Mixed',
  ],

  // Word count options
  WORD_COUNT_OPTIONS: [10, 15, 20, 25, 30],

  // Default values
  DEFAULT_GRADE_LEVEL: '6-8',
  DEFAULT_SUBJECT: 'English Literature',
  DEFAULT_WORD_COUNT: 20,
};

export const ARTIFACT_FORMATS = [
  {
    id: 'flashcards',
    label: 'Flashcards',
    description: 'Print and cut flashcards with word on front, definition on back',
  },
  { id: 'quiz', label: 'Vocabulary Quiz', description: 'Multiple choice quiz with answer key' },
  {
    id: 'worksheet',
    label: 'Fill-in-the-Blank Worksheet',
    description: 'Sentences with blanks for vocabulary practice',
  },
  {
    id: 'word-study',
    label: 'Word Study Guide',
    description: 'Detailed study guide with roots, definitions, and examples',
  },
  { id: 'matching', label: 'Matching Exercise', description: 'Match words to definitions' },
  {
    id: 'crossword',
    label: 'Crossword Puzzle',
    description: 'Interactive crossword with vocabulary clues',
  },
  {
    id: 'root-chart',
    label: 'Latin/Greek Root Chart',
    description: 'Chart organizing words by their roots',
  },
];
